import React, { useMemo } from 'react';
import { 
  Autocomplete,
  TextField,
  CircularProgress,
  Box
} from '@mui/material';
import { formatSchoolName } from '../../utils/nameFormatter';
import { renderSchoolOption, filterSchoolOptions } from './schoolOption';
import { useTeamSchoolCache } from '../../hooks/teamCacheService';

const InitialSchoolSelector = ({ selectedSchool, onSchoolChange }) => {
  const { 
    schools, 
    loading, 
    error, 
  } = useTeamSchoolCache();

  // Sort schools and memoize the result
  const sortedSchools = useMemo(() => {
    return [...schools].sort((a, b) => 
      formatSchoolName(a.name).localeCompare(formatSchoolName(b.name))
    );
  }, [schools]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box color="error.main" p={2}>
        Error loading schools: {error}
      </Box>
    );
  }

  return (
    <Autocomplete
      fullWidth
      options={sortedSchools}
      getOptionLabel={(option) => formatSchoolName(option.name)}
      value={selectedSchool || null}
      onChange={(event, newValue) => {
        onSchoolChange({ target: { value: newValue?.uuid || '' } });
      }}
      isOptionEqualToValue={(option, value) => option.uuid === value?.uuid}
      filterOptions={filterSchoolOptions}
      renderOption={renderSchoolOption}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select a School"
          placeholder="Search by name or location..."
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};

export default InitialSchoolSelector;